import styled, { css } from 'styled-components';
import { AppointmentRequestStatus } from '../../../medrefer-web-sdk/api/models/AppointmentRequestsModel';

export interface StyledBadgeProps {
    type?: AppointmentRequestStatus;
}

const cssGreen = css`
    background: #eaf9ec;
    color: #4cc13a;
    &:after {
        background: #4cc13a;
    }
`;

const cssRed = css`
    background: #ffeef3;
    color: #f92763;

    &:after {
        background: #f92763;
    }
`;

const cssYellow = css`
    background: #fffae6;
    color: #ffa900;

    &:after {
        background: #ffa900;
    }
`;

const cssGrey = css`
    background: #eeeef2;
    color: #747478;

    &:after {
        background: #747478;
    }
`;

export const StyledBadge = styled.span<StyledBadgeProps>`
    display: block;
    position: relative;
    border-radius: 13px;
    font-weight: 600;
    font-size: 10px;
    color: black;
    padding: 6px 11px 7px 22px;
    height: 27px;
    box-sizing: border-box;
    width: fit-content;

    &:after {
        position: absolute;
        top: 11px;
        left: 11px;
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }
    ${(props) => props.type === AppointmentRequestStatus.APPROVED && cssGreen}
    ${(props) => props.type === AppointmentRequestStatus.RESPONDED && cssGrey}
    ${(props) => props.type === AppointmentRequestStatus.PENDING && cssRed}
    ${(props) => props.type === AppointmentRequestStatus.CANCELED && cssYellow}
`;
